import { type OpportunitiesSearchOptions } from "@repo/api";
import { Checkbox, Text } from "@repo/skapa";
import { T, t } from "@repo/translation";
import { type ChangeEvent } from "react";

import { CheckboxHeader, HideOnMobileHeader } from "./ProjectsTable.styled";
import { SortableHeaderCell } from "./SortableHeaderCell";

interface ProjectsTableHeaderProps {
  isAllSelected: boolean;
  onSelectAll: (e: ChangeEvent<HTMLInputElement>) => void;
  onSort: (sortKey: string) => void;
  options: OpportunitiesSearchOptions;
}

export const ProjectsTableHeader = ({
  isAllSelected,
  onSelectAll,
  onSort,
  options,
}: ProjectsTableHeaderProps) => {
  return (
    <tr>
      <CheckboxHeader>
        <Checkbox
          id="project-table-select-all"
          value="Select all"
          subtle
          checked={isAllSelected}
          onChange={onSelectAll}
          aria-label={t("action.select_all")}
        />
      </CheckboxHeader>
      <SortableHeaderCell
        sortKey="classification"
        sort={onSort}
        options={options}
        hideOnMobile
      />
      <th>
        <Text>
          <T translationKey="label.customer" />
        </Text>
      </th>
      <SortableHeaderCell
        sortKey="createdDate"
        sort={onSort}
        translationKey="label.created"
        options={options}
      />
      <SortableHeaderCell
        sortKey="opportunityType"
        sort={onSort}
        translationKey="label.type"
        options={options}
        hideOnMobile
      />
      <SortableHeaderCell
        sortKey="status"
        sort={onSort}
        translationKey="label.status"
        options={options}
        hideOnMobile
      />
      <SortableHeaderCell
        sortKey="value"
        sort={onSort}
        translationKey="label.value"
        options={options}
        hideOnMobile
      />
      <HideOnMobileHeader>
        <Text>
          <T translationKey="label.owner" />
        </Text>
      </HideOnMobileHeader>
      <th aria-label={t("label.actions")} />
    </tr>
  );
};
